var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
export default React.memo(function (props) {
    return (React.createElement("svg", __assign({ width: 48, height: 48, viewBox: "0 0 48 48", xmlns: "http://www.w3.org/2000/svg" }, props),
        React.createElement("path", { d: "M36.188 12.5a2.813 2.813 0 012.807 2.647l.005.165v15a2.813 2.813 0 01-2.647 2.808l-.166.005h-.937v.938a2.813 2.813 0 01-2.641 2.807l-.172.005H11.814A2.812 2.812 0 019 34.062v-15a2.812 2.812 0 012.813-2.812h.937v-.938a2.813 2.813 0 012.647-2.807l.165-.005h20.626zm-3.75 5.625H11.811a.937.937 0 00-.937.938v15c0 .517.42.937.938.937h20.624c.518 0 .938-.42.938-.938v-15a.937.937 0 00-.938-.937zm3.75-3.75H15.561a.938.938 0 00-.93.828l-.007.11v.937h17.813a2.813 2.813 0 012.807 2.641l.005.172V31.25h.938c.48 0 .877-.362.93-.828l.007-.11v-15a.938.938 0 00-.828-.93l-.11-.007z", fill: "currentColor", fillRule: "nonzero", stroke: "none", strokeWidth: 1 })));
});
